import React, { Component } from "react";
import CookieService from "../../../shared/services/cookiesService";
import configuration from "./../../../config.json";

class ReportConstructorVeicleReportCheck extends Component {
  constructor(props) {
    super(props);
    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;

    const vehicleReports = !!localStorage.getItem(configuration.vehicleReports)
      ? JSON.parse(localStorage.getItem(configuration.vehicleReports))
      : [];

    let vehicleReport = vehicleReports.filter((x) => {
      return x.email === email;
    })[0];

    if (vehicleReport === undefined) {
      vehicleReport = {
        email,
        id: null,
      };

      vehicleReports.push(vehicleReport);

      localStorage.setItem(configuration.vehicleReports, JSON.stringify(vehicleReports));
    }

    this.state = {
      vehicleReport,
    };
  }

  onChange(e) {
    const { vehicleReport } = this.state;
    const { customReport } = this.props;

    const vehicleReports = !!localStorage.getItem(configuration.vehicleReports)
      ? JSON.parse(localStorage.getItem(configuration.vehicleReports))
      : [];

    vehicleReports.forEach((item) => {
      if (vehicleReport.email === item.email) {
        item.id = e.target.checked ? customReport.id : null;

        this.setState({ vehicleReport: item });
      }
    });

    localStorage.setItem(configuration.vehicleReports, JSON.stringify(vehicleReports));
  }

  render() {
    const { customReport } = this.props;
    const { vehicleReport } = this.state;

    if (customReport === null || customReport.buildType !== 0) {
      return null;
    }

    return (
      <div>
        <input
          type="checkbox"
          key={customReport.id + "" + vehicleReport.id === customReport.id}
          checked={vehicleReport.id === customReport.id}
          onChange={this.onChange.bind(this)}
        />
        <span>Использовать отчет при просмотре маршрута</span>
      </div>
    );
  }
}

export default React.memo(ReportConstructorVeicleReportCheck);
